import { useMemo } from 'react';
import { numeroParaExtensoDinheiro } from '../utils/currency';

export function useValorExtenso(valor: number | undefined): string {
  return useMemo(() => {
    if (!valor || valor <= 0) return '';
    try {
      return numeroParaExtensoDinheiro(valor);
    } catch {
      return '';
    }
  }, [valor]);
}
